// import React from 'react'

// const CandidateProgress = () => {
//   return (
//     <div>CandidateProgress</div>
//   )
// }

// export default CandidateProgress



import React from 'react'
import {
    Card,
    CardBody,
    Col,
    Container,
    Input,
    InputGroup,
    InputGroupText,
    Row,
    Table,
} from "reactstrap";
// import NavLink from "reactstrap/es/NavLink";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { PageSubHeader } from 'components/CommonLayouts/PageSubHeader';

const CandidateProgress = () => {
    const navigate = useNavigate();
    const progressTimeline = [
        {
            stage: "Candidate Submitted",
            status: "Received",
            submittedOn: "dd/mm/yyyy",
            feedbackRemarks: "Resume uploaded by vendor",
            actionTakenBy: "Staffing Solutions",
        },
        {
            stage: "Application Screening",
            status: "Moved to Screening",
            submittedOn: "dd/mm/yyyy",
            feedbackRemarks: "Meets basic skills and experience",
            actionTakenBy: "HR Team",
        },
        {
            stage: "Screening Feedback",
            status: "Selected",
            submittedOn: "dd/mm/yyyy",
            feedbackRemarks: "Shortlisted for technical interview",
            actionTakenBy: "HR Team",
        },
        {
            stage: "Technical Interview",
            status: "Scheduled",
            submittedOn: "dd/mm/yyyy",
            feedbackRemarks: "Scheduled for 06-Apr, virtual",
            actionTakenBy: "Recruitment Coordinator",
        },
        {
            stage: "Technical Interview",
            status: "Rejected",
            submittedOn: "dd/mm/yyyy",
            feedbackRemarks: "Candidate rejected",
            actionTakenBy: "Tech Panel",
        },
    ];

    return (
        <div className='page-content'>
            <Container fluid className="py-0 px-0">
                 <PageSubHeader
                                          
                                          heading={"View Candidate Progress"}
                                          PageSubHeader={"Discover Open Roles. Align Candidates. Boost Submissions."}
                                          routePath={"Home"}
                                          pageName={"View Candidate Progress"} />
                <Row className='px-4 py-4'>
                    {/* <Row className="py-2 px-4">
                        <p className='sub-heading'>View Job Postings/ JD1023/ View Post/ C-001/ View Candidate Progress</p>
                        <h2 className='heading'>View Candidate Progress</h2>
                    </Row> */}
                    <Row className='p-2'>

                        <Row className='  p-3 mx-4   data'>

                            <Col size={6}><p className='info-head'>Candidate Name</p>
                                <p className='info'>Riya Sharma</p>
                                <p className='info-head'>Candidate ID</p>
                                <p className='info'>C-001</p>
                                <p className='info-head'>Job Position Applied</p>
                                <p className='info'>Frontend Developer</p>
                                <p className='info-head'>Job ID</p>
                                <p className='info'>JD1023</p>
                            </Col>
                            <Col size={6}
                            >
                                <p className='info-head'>Candidate Email</p>
                                <p className='info'>riyasharma@email.com</p>
                                <p className='info-head'>Candidate Mobile Number</p>
                                <p className='info'>90XXXXXXXX</p>
                                <p className='info-head'>Candidate Profile Submitted On</p>
                                <p className='info'>dd/mm/yyyy</p>
                                <p className='info-head'>Resume</p>
                                <p className='resume' style={{ color: "#1E9EFB", display: "flex", marginLeft: "8px" }} ><i
                                    className="fa-solid fa-paperclip"
                                    title="Attach"
                                    style={{ color: '#1E9EFB', transform: 'rotate(-45deg)', fontSize: '19px' }}
                                ></i><p>View Resume</p></p>
                            </Col>

                        </Row>



                        <Row className="py-2 px-4 mt-4">
                            <h2 className='heading'>Progress Timeline</h2>
                        </Row>
                    </Row>
                    <Row className="  ms-2">
                        <Card>
                            <CardBody>
                                <div className="table-responsive ">
                                    <Table className="table mb-0 border: 0.4px solid #D4D4D4;">
                                        <thead>
                                            <tr>
                                                <th>Stage</th>
                                                <th>Status</th>
                                                <th>Submitted On</th>
                                                <th>Feedback/ Remarks</th>
                                                <th>Action Taken By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {progressTimeline.map((candidate, index) => (
                                                <tr key={index}>
                                                    <td>{candidate.stage}</td>
                                                    <td>
                                                        {candidate.status === "Rejected" ? "❌" : "✅"} {candidate.status}
                                                    </td>
                                                    <td>{candidate.submittedOn}</td>
                                                    <td>{candidate.feedbackRemarks}</td>
                                                    <td>{candidate.actionTakenBy}</td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Row>
                </Row>
            </Container>
        </div>
    );
};

export default CandidateProgress;
